import React, { forwardRef } from 'react';
import { InputAffix, InputAffixProps } from './InputAffix';
import { InputBase, InputBaseProps } from './InputBase';

export type InputProps = InputBaseProps & InputAffixProps;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, status = 'info', disabled, prefix, suffix, width, flex, size, ...props }, ref) => {
    const getCommonInputBaseProps = () => ({
      ...props,
      ref,
      status,
      disabled,
      width,
      size,
    });

    return prefix || suffix ? (
      <InputAffix
        className={className}
        status={status}
        disabled={disabled}
        prefix={prefix}
        suffix={suffix}
        width={width}
        flex={flex}
        size={size}
      >
        <InputBase {...getCommonInputBaseProps()} flex={1} leftAddon={prefix} rightAddon={suffix} />
      </InputAffix>
    ) : (
      <InputBase {...getCommonInputBaseProps()} flex={flex} className={className} />
    );
  },
);
